import state from './store/state'

export default {
    state
};